<template>
  <div class="pay-modal">
    <Modal v-model="modalState" class="payModalBox" @on-cancel="cancelHandle" :mask-closable="false" class-name="vertical-center-modal">
      <span slot="header"></span>
      <div class="modal-content">
        <div class="header">支付</div>
        <Form ref="form" :model="form" :rules="ruleForm" @submit.native.prevent>
          <div class="head_title">订单信息</div>
          <div class="basic">
            <div class="form_item name">
              <div class="title">套餐名称</div>
              <div class="value">{{parseFloat(pkg.amount)}}元{{pkg.integral}}积点</div>
            </div>
            <div class="form_item expire">
              <div class="title">有效期</div>
              <div class="value" v-if="pkg.type == 1 && pkg.expiryTime">{{pkg.expiryTime | dataFormat('dateTime.short2')}}</div>
              <div class="value" v-else>{{(new Date()).getTime() | getMCardAfterMonthsTimestamp(pkg.vip, pkg.vipExpire) | dataFormat('dateTime.short2')}}</div>
            </div>
            <div class="form_item price">
              <div class="title">支付金额</div>
              <div class="value"><span style="font-size:12px">¥</span> {{pkg.amount | padZeroPlaces}}</div>
            </div>
            <FormItem class="form_item remark" prop="remarks">
              <div class="title">备注信息</div>
              <div class="value">
                <img src="@/assets/images/icons/member/bj.png">
                <Input type="text" v-model.trim="form.remarks" @on-enter="ok" placeholder="请填写备注信息…" />
              </div>
            </FormItem>
          </div>
          <div class="payment">
            <div class="head_title">选择支付方式</div>
            <FormItem class="form_item mth" prop="type">
              <div class="value">
                <RadioGroup v-model="form.type">
                  <div class="item">
                    <Row>
                      <Col span="12">
                        <Radio label="1" class="kj">
                          <img src="@/assets/images/icons/member/kj.png">
                          <div class="name">快捷支付<span>（仅支持个人支付）</span></div>
                        </Radio>
                      </Col>
                      <Col span="12" style="position:relative;top:2px;">
                        <Radio label="3" class="alipay">
                          <img src="@/assets/images/icons/member/alipay.png">
                          <div class="name">支付宝<span>（仅支持个人支付）</span></div>
                        </Radio>
                      </Col>
                    </Row>
                  </div>
                  <div class="item">
                    <Row>
                      <Col span="12">
                        <Radio label="2" class="yl">
                          <img src="@/assets/images/icons/member/yl.png">
                          <div class="name">银联支付<span>（支持个人和企业支付）</span></div>
                        </Radio>
                      </Col>
                      <Col span="12" style="position:relative;top:2px;">
                        <Radio label="4" class="wxpay">
                          <img src="@/assets/images/icons/member/wxpay.png">
                          <div class="name">微信支付<span>（仅支持个人支付）</span></div>
                        </Radio>
                      </Col>
                    </Row>
                  </div>
                </RadioGroup>
              </div>
            </FormItem>
          </div>
        </Form>
        <div class="footer">
          <Checkbox v-model="isAgree" class="tip">我已同意O-TECH<a class="line2" @click.stop.prevent="toPrivacy">《充值协议及条款》</a></Checkbox>
          <Button type="primary" :loading="isShowLoader" @click="ok">
            <span v-if="!isShowLoader"><span>支付</span></span>
            <span v-else>支付</span>
          </Button>
        </div>
      </div>
      <div slot="footer"></div>
      <form ref="payForm" :action="pay.url" method="post" style="display:none">
        <input type="text" name="cmd_id" id="cmd_id" v-model="pay.cmdId">
        <input type="text" name="mer_cust_id" id="mer_cust_id" v-model="pay.merCustId">
        <input type="text" name="version" id="version" v-model="pay.version">
        <textarea name="check_value" v-model="pay.sign"></textarea>
      </form>
    </Modal>
    <Loader :loadType="1" v-show="isShowLoader" class="black"></Loader>
  </div>
</template>

<script>
import Loader from '@/components/layout/Loader'
import { mapMutations } from 'vuex'

export default {
  name: 'PayModal',
  components: { Loader },
  props: {
    pkg: {
      type: Object,
      default: () => { return {} },
      required: false
    }
  },
  data () {
    return {
      modalState: false,
      isSubmit: false,
      isShowLoader: false,
      isAgree: false,
      pay: {},
      form: {
        type: '1',
        remarks: ''
      },
      ruleForm: {
        type: [
          { required: true, message: '请选择支付方式', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    pkg (newVal, oldVal) {
      if (newVal.id) {
        this.modalState = true
      } else {
        this.modalState = false
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$root.$on('clearFormCloseModal', () => {
        this.$refs['form'] && this.$refs['form'].resetFields()
      })
    })
  },
  methods: {
    toPrivacy () {
      this.setPrivacyModalState(true)
    },
    cancelHandle (event) {
      this.$emit('update:pkg', {})
      this.$root.$emit('clearFormCloseModal', event)
    },
    ok () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (!this.isAgree) {
            this.$Message.warning({content: '请阅读并同意O-TECH《充值协议及条款》', closable: true})
          } else if (!this.isSubmit) {
            this.$Loading.start()
            this.isSubmit = true
            this.isShowLoader = true
            this.form.type = parseInt(this.form.type)
            this.$api.account.member.recharge.pay(this._.assign({
              packageId: parseInt(this.pkg.id),
              redirect: location.protocol + '//' + location.host + '/#/my/recharge/state/{0}',
              callback: location.protocol + '//' + location.host + '/api/pay/redirect'
            }, this.form), {
              success: response => {
                this.$Loading.finish()
                this.isSubmit = false
                this.isShowLoader = false
                if (response.data.code === 200) {
                  this.pay = response.data.data
                  this.$nextTick(() => {
                    this.$refs['payForm'].submit()
                    // this.modalState = false
                  })
                } else {
                  this.$Message.warning({content: this.$t('common.codeError'), closable: true})
                }
              },
              error: errorMsg => {
                this.$Loading.error()
                this.isSubmit = false
                this.isShowLoader = false
                this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
              }
            })
          }
        }
      })
    },
    ...mapMutations({
      setPrivacyModalState: 'account/setPrivacyModalState'
    })
  }
}
</script>
<style scoped>
.basic{
  border: 1px solid#F1F1F1;
  border-radius: 3px;
}
.head_title{
  color: #999;
  font-size: 13px;
  margin-bottom: 12px;
}
.basic .form_item{
  border-bottom: 1px solid #F1F1F1;
  padding: 10px 0 10px 145px;
  margin: 0;
  background-color: #fff;
}
.basic .form_item:last-child{
  border-bottom: 0 none;
}
.basic .form_item .title{
  background-color: #F8F8F8;
  width: 125px;
  /*padding: 10px 0 10px 20px;*/
  padding-left: 20px;
  height: 100%;
  display: flex;
  align-items: center;
}
.basic .form_item .value{
  color: #333;
}
.payment .head_title{
  margin-top: 15px;
}
.form_item{
  position: relative;
  padding-left: 78px;
  margin-bottom: 20px;
}
.form_item .title{
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  color: #333;
  font-size: 14px;
}
.form_item .value{
  color:#999;
  font-size: 14px;
}
.basic .form_item.remark{
  padding-left: 0;
  border: 0 none;
  padding-top: 0;
  padding-bottom: 0;
}
.basic .form_item.remark >>> .ivu-form-item-content{
  padding-left: 142px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.basic .form_item.remark .value{
  position: relative;
  padding-right: 10px;
}
.form_item.remark img{
  width: 14px;
  position: absolute;
  top: 11px;
  left: 2px;
  z-index: 1;
}
.basic .form_item.remark .value >>> .ivu-input{
  padding-left: 22px;
  border: 0 none;
  outline: none;
}
.basic .form_item.remark .value >>> .ivu-input:focus{
  border: 0 none;
  box-shadow: none;
}
.form_item.mth{
  padding-left: 0;
  border: 1px solid #F1F1F1;
}
.form_item.mth >>> .ivu-form-item-content{
  position: relative;
  padding: 6px 15px;
}
.form_item.mth >>> .ivu-radio-wrapper img{
  display: inline-block;
  height: 17px;
  position: relative;
  top: 8px;
}
.form_item.mth >>> .ivu-radio-wrapper.kj .name,
.form_item.mth >>> .ivu-radio-wrapper.yl .name{
  position: relative;
  top: 4px;
}
.form_item.mth >>> .ivu-radio-wrapper.alipay img{
  height: 23px;
}
.form_item.mth >>> .ivu-radio-wrapper.wxpay img{
  height: 22px;
}
.form_item.mth >>> .ivu-radio{
  position: relative;
  top: 4px;
  margin-right: 4px;
}
.form_item.mth >>> .ivu-radio-wrapper.alipay .ivu-radio{
  top: 0px;
}
.form_item.mth >>> .ivu-radio-wrapper.wxpay .ivu-radio{
  top: 0px;
}
.form_item.mth >>> .ivu-radio-wrapper .name{
  color: #333;
  padding-left: 0px;
  font-size: 12px;
  line-height: 1.5;
  display: inline-block;
}
.form_item.mth >>> .ivu-radio-wrapper .name span{
  color: #1F8AFD;
  font-size: 12px;
}
.form_item.mth >>> .ivu-radio-group{
  width: 100%;
}
.form_item.mth >>> .ivu-radio-group .item{
  margin-bottom: 10px;
}
.payModalBox .ivu-btn{
  border: 0 none;
  background-image: linear-gradient(-90deg, #0F7EF3 0%, #27BEFE 100%);
  border-radius: 3px;
  color: #fff;
  text-align: center;
  width: 350px;
  height: 36px;
  line-height: 36px;
  padding: 0;
  margin: 0 auto 10px;
  font-size: 15px;
}
.payModalBox .footer{
  text-align: center;
  margin-bottom: 15px;
}
.payModalBox .footer .tip{
  color: #999;
  font-size: 13px;
  margin-bottom: 10px;
}
.payModalBox .footer .tip a,
.payModalBox .footer .tip a:hover{
  color: #E7A203;
}
.payModalBox .footer .tip a.line2:after{
  background-color: #E7A203;
}
</style>
<style>
  @media print,screen and (min-width:1366px) {
    .payModalBox .vertical-center-modal,
    .payModalBox .ivu-modal{
      width: 540px !important;
    }
  }
  @media print,screen and (max-width:1365px) {
    .payModalBox .vertical-center-modal,
    .payModalBox .ivu-modal{
      width: 540px !important;
    }
  }
  .payModalBox .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: -20px;
  }
  .payModalBox .vertical-center-modal .ivu-modal{
    top: 0;
  }
  .payModalBox .ivu-modal-content{
    border: 0.5px solid #D8D8D8;
    border-radius: 3px;
    padding: 0 5px;
  }
  .payModalBox .ivu-modal-header,
  .payModalBox .ivu-modal-footer{
    display: none;
  }
  .payModalBox .header{
    padding: 0px 16px 12px 2px;
    border-bottom: 0.5px solid #D8D8D8;
    font-size: 16px;
    color: #333;
    margin-bottom: 15px;
  }
  .payModalBox .footer{
    margin-top: 25px;
    margin-bottom: 8px;
  }
  .payModalBox .ivu-modal-close{
    top: 16px;
    right: 22px;
  }
  .payModalBox .ivu-modal-close:hover{
    text-decoration: none;
    box-shadow: none;
  }
  .payModalBox .ivu-input{
    border: 0.5px solid #DBDBDB;
    padding-left: 25px;
    border-radius: 2px;
    font-size: 14px;
  }
  .payModalBox .ivu-radio{
    margin-right: 3px;
  }
  .payModalBox .ivu-radio-wrapper{
    font-size: 1.3rem;
  }
  .payModalBox .ivu-form-item{
    margin-bottom: 15px;
  }
  .payModalBox .ivu-form-item-error{
    margin-bottom: 30px;
  }
  .payModalBox .ivu-form-item.ivu-form-item-error:last-child{
    margin-bottom: 35px;
  }
  .payModalBox .ivu-form-item-error-tip{
    font-size: 12px;
    padding-top: 9px;
    padding-bottom: 10px;
  }
  .payModalBox .ivu-input:focus{
    border-color: #1F8AFD;
  }
  .payModalBox .ivu-modal-close .ivu-icon-ios-close-empty{
    width: 15px;
    height: 15px;
    background: url("~@/assets/images/icons/close.png") 0 0 no-repeat transparent;
    background-size: 15px;
  }
  .payModalBox .ivu-modal-close .ivu-icon-ios-close-empty:before{
    content: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/zh-CN/recharge/payModal.vue